import { z } from 'zod';
import { PODCAST_TYPES } from '../constants.js';
export const createPodcastSchema = z.object({
    title: z.string().min(1).max(200),
    description: z.string().optional(),
    author: z.string().optional(),
    language: z.string().default('en'),
    category: z.string().optional(),
    podcastType: z.enum(PODCAST_TYPES).default('episodic'),
    explicit: z.boolean().default(false),
    artworkUrl: z.string().optional(),
    /** <itunes:owner> email; Apple/Spotify send ownership verification here. */
    ownerEmail: z.string().email().max(320).nullable().optional(),
});
export const updatePodcastSchema = createPodcastSchema.partial();
//# sourceMappingURL=podcast.schemas.js.map